<template>
  <div
    ref="stepBox"
    class="step-box"
  >
    <div class="step">
      <el-steps
        ref="steps"
        :active="item.step_id * 1 - 1"
        align-center
      >
        <template v-for="(step, stepIndex) in steps">
          <el-step :key="stepIndex">
            <template slot="icon">
              <i class="el-icon-check" />
              <span class="step-num">{{ stepIndex + 1 }}</span>
              <span class="step-num active">{{ stepIndex + 1 }}</span>
            </template>
            <template slot="title">
              <div
                class="title"
                v-text="step.name"
              />
            </template>
            <template slot="description">
              <div class="ops-btn">
                <template v-if="showOpenBtn">
                  <!-- 开户 -->
                  <el-button @click="toInitAder(item.customer_id, item.owner)">开户</el-button>
                </template>
                <template v-if="showOpeningBtn">
                  <!-- 开户中 -->
                  <div class="status-btn-icon">开户中</div>
                </template>
                <template v-if="showUpStepBtn">
                  <el-button @click="handleUpdateStep">更新进度</el-button>
                </template>
              </div>
            </template>
          </el-step>
        </template>
      </el-steps>
    </div>

    <!-- dialog -->
    <form-dialog
      :visible.sync="stepForm.display"
      title="更新进度"
      :loading="stepForm.loading"
      width="500px"
      @submit="submitStepForm"
    >
      <el-form
        ref="stepForm"
        :model="stepForm.form"
        :rules="stepForm.rules"
        label-width="100px"
      >
        <el-form-item
          label="业务阶段"
          prop="step_id"
        >
          <el-radio-group v-model="stepForm.form.step_id">
            <el-radio
              v-for="(item, index) in stepNextOption"
              :key="index"
              :label="item.id"
            >
              {{
                item.name
              }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="进度内容"
          prop="remark"
        >
          <el-input
            ref="step_form_content"
            v-model="stepForm.form.remark"
            type="textarea"
            :rows="4"
          />
        </el-form-item>
      </el-form>
    </form-dialog>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import FormDialog from '@/components/FormDialog';
// import $conf from '@/common/conf';
import IconWaiting from '@/assets/image/icon/waiting-icon.png';

const req = new Request();

export default {
  name: 'Step',
  components: { FormDialog },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    detailType: {
      type: String,
      required: true,
      default: '',
    },
  },
  data: () => ({
    iconWaiting: IconWaiting,
    stepForm: {
      form: {
        step_id: '',
        remark: '',
      },
      rules: {
        step_id: [{ required: true, message: '请选择进度', triggle: 'change' }],
        remark: [
          { required: true, message: '进度内容必填', triggle: 'change' },
          { min: 15, max: 2014, message: `长度为15-1024`, triggle: 'change' },
        ],
      },
      display: false,
      loading: false,
    },
  }),
  computed: {
    // 是否开户阶段
    isOpeningStatus() {
      return Number(this.item.step_id) === 4;
    },

    showOpenBtn() {
      return (
        this.isOpeningStatus &&
        this.item.audit === '-1' &&
        this.detailType === '1'
      );
    },

    showOpeningBtn() {
      return (
        this.isOpeningStatus &&
        (this.item.audit === '0' || this.item.audit === '1')
      );
    },

    showUpStepBtn() {
      return !this.isOpeningStatus && this.detailType === '1';
    },
    stepNextOption() {
      const stepId = Number(this.item.step_id);
      const steps = [...this.steps];
      let ret = [];
      if (steps.length > 0) {
        const stepActIn = steps.findIndex((step) => Number(step.id) === stepId);
        ret = steps.splice(stepActIn, 2);
      }
      return ret;
    },
  },

  created() {
    this.judgeStepVertical();
    this.setInitAderFinished();
  },
  methods: {
    // async 提交进度
    async processSubmit() {
      try {
        const params = {
          ...this.stepForm.form,
          customer_id: this.item.customer_id,
          product_id: this.item.product_id,
        };
        this.submitLoading = true;
        await req
          .send(req.Apis.sales.customerStage2.setProductStep, params)
          .fin(() => {
            this.submitLoading = false;
          });
        this.stepForm.display = false;
        this.$message.success('更新成功！');
        // 通知父层更新进度完成
        this.$emit('update-step-succ');
      } catch (err) {
        this.$message.error(`更新进度失败：${err.message || '未知错误'}`);
      }
    },

    // 更新进度
    handleUpdateStep() {
      this.stepForm.display = true;
      this.stepForm.form.remark = '';
      this.stepForm.form.step_id = this.item.step_id;
      // 自动聚焦内容
      this.$nextTick(() => {
        this.$refs.step_form_content.focus();
      });
    },

    // 提交更新进度
    submitStepForm() {
      this.$refs['stepForm'].validate((valid) => {
        if (valid) {
          this.processSubmit();
        } else {
          return false;
        }
      });
    },

    // 跳转开户
    toInitAder(id, owner = '') {
      let formType = 'init'; // 开户的标识
      let productInfo = JSON.stringify(this.item);
      this.$router.push({
        name: 'AdvertiserManagePrivateInitAder',
        query: { id, owner, formType, productInfo },
      });
    },

    matchStep(step) {
      return this.item.audit !== '' ? Number(this.item.audit) === step : false;
    },

    judgeStepVertical() {
      if (this.showOpenBtn || this.showOpeningBtn || this.showUpStepBtn) {
        this.$nextTick(() => {
          this.$refs.stepBox.style.verticalAlign = 'inherit';
        });
      }
    },

    setInitAderFinished() {
      if (this.isOpeningStatus && this.item.audit === '2') {
        this.$nextTick(() => {
          if (
            this.$refs.steps &&
            this.$refs.steps.$children &&
            this.$refs.steps.$children.length > 0
          ) {
            let lastStep = this.$refs.steps.$children[
              this.$refs.steps.$children.length - 1
            ];
            if (lastStep && lastStep.$el && lastStep.$el.firstChild) {
              lastStep.$el.firstChild.setAttribute(
                'class',
                'el-step__head is-finish',
              );
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.step-box {
  height: 88px;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 4000px;
  /deep/ .dialog-title {
    text-align: left;
  }
  /deep/ .el-form-item__label {
    text-align: center;
  }
  /deep/ .el-form-item__content {
    text-align: left;
  }
  .step {
    /deep/ .el-button {
      font-size: 12px;
      font-weight: bold;
      color: #2f9eff;
      padding: 7px 10px;
      border-radius: 4px;
      border: 1px solid #2f9eff;
    }
    /deep/ .el-step__icon.is-text {
      border: 0;
    }

    /deep/ .el-step__line {
      background: transparent;
      left: 78%;
      right: -22%;
      .el-step__line-inner {
        border-style: dashed;
        border-width: 1px !important;
        width: 100% !important;
      }
    }
    /deep/ .is-finish {
      .el-step__line-inner {
        border-color: #2f9eff;
      }
      .el-step__icon.is-text {
        border: 1px solid;
      }
      .step-num {
        display: none;
      }
      .step-num.active {
        display: none;
      }
      .el-icon-check {
        display: block;
      }
      .title {
        color: rgba(47, 158, 255, 1);
      }
    }
    /deep/ .is-process {
      .el-step__line-inner {
        border-color: #ddd;
      }
      border-color: #22affb;
      .step-num {
        display: none;
      }
      .step-num.active {
        display: block;
      }
      .el-icon-check {
        display: none;
      }
      .title {
        color: rgba(47, 158, 255, 1);
      }
      .ops-btn {
        display: block;
        margin-top: 10px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    /deep/ .el-step__description {
      margin-top: 0;
    }
    /deep/ .is-wait {
      .el-step__line-inner {
        border-color: #ddd;
      }
      border-color: #f3f5f5;
      .step-num {
        display: block;
      }
      .step-num.active {
        display: none;
      }
      .el-icon-check {
        display: none;
      }
      .title {
        color: #909399;
      }
    }

    .step-num {
      border-radius: 50%;
      display: block;
      width: 100%;
      color: #909399;
      background: #f3f5f5;
      width: 24px;
      line-height: 24px;
      height: 24px;

      &.active {
        color: #fff;
        background: linear-gradient(
          180deg,
          rgba(113, 198, 255, 1) 0%,
          rgba(47, 158, 255, 1) 100%
        );
      }
    }

    .title {
      font-size: 14px;
      font-weight: 500;
      color: rgba(47, 158, 255, 1);
      // line-height: 20px;
      // padding-top: 3px;
      line-height: 15px;
      margin-top: 10px;
    }

    .ops-btn {
      display: none;
    }

    .status-btn-icon {
      display: inline-block;
      padding: 6px 20px;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      font-weight: 600;
      color: #f6b423;
      white-space: nowrap;
      line-height: 24px;

      img {
        position: relative;
        width: 16px;
        top: 3px;
        margin-right: 6px;
      }
    }
  }
}
</style>
